"use client";

import { Box, CircularProgress, Typography } from "@mui/material";
import { useEffect, useState } from "react";

type TimedCircularLoaderProps = {
  durationMs?: number;
  size?: number;
  onComplete?: () => void;
};

export default function TimedCircularLoader({
  durationMs = 40000,
  size = 96,
  onComplete,
}: TimedCircularLoaderProps) {
  const [progress, setProgress] = useState(0);

  useEffect(() => {
    const start = Date.now();
    const interval = 100;

    const timer = setInterval(() => {
      const elapsed = Date.now() - start;
      const percent = Math.min(Math.round((elapsed / durationMs) * 100), 100);

      setProgress(percent);

      if (percent >= 100) {
        clearInterval(timer);
        setTimeout(() => onComplete?.(), 500); 
      }
    }, interval);

    return () => clearInterval(timer);
  }, [durationMs, onComplete]);

  return (
    <Box
      sx={{
        position: "relative",
        display: "inline-flex",
        color: "#000",
      }}
    >
      {/* Circular loader */}
      <CircularProgress
        variant="determinate"
        value={progress}
        size={size}
        thickness={4}
        color="inherit"
      />

      {/* Percentage inside */}
      <Box
        sx={{
          position: "absolute",
          inset: 0,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <Typography fontWeight={600}>{progress}%</Typography>
      </Box>
    </Box>
  );
}
